import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const TYPES = {
    REGION: 'region',
    ROAD: 'road'
}

export const EDIT_STATUS = {
    LIST: 'list',
    EDIT: 'edit'
}


let mouseTool

const DefaultOption = {
    color: 'rgba(0, 176, 255, 0.3)',
    showBorder: true,
    borderColor: '#80d8ff'
}

const DefaultRoadOption = {
    color: 'rgba(0, 176, 255, 1)',
    width: 8
}

const registerPolygonEditor = (polygon, onUpdate) => {
    if (polygon.__editor) {
        return
    }

    const editor = new window.TMap.tools.GeometryEditor({
        map: window.map,
        overlayList: [
            {
                overlay: polygon,
                id: 'editor-polygon'
            }
        ],
        actionMode: window.TMap.tools.constants.EDITOR_ACTION.INTERACT,
        activeOverlayId: 'editor-polygon',
        snappable: true
    })
    polygon.__editor = editor
}

export default {
    namespaced: true,
    state: {
        list: [
            {
                id: 1,
                name: 'test'
            }
        ],
        editing_plate: {
            name: '',
            coordinates: [],
            region: [],
            region_complete: false
        },
        selected_road_layer: -1,
        selected_region_layer: -1,
        road_layers: [],
        region_layers: [],
        edit_type: TYPES.REGION,
        edit_status: EDIT_STATUS.LIST
    },
    mutations: {
        setList(state, list) {
            state.list = list
        },
        changePlate(state, editing_plate) {
            state.editing_plate = editing_plate
        },
        changeEditType(state, type) {
            state.edit_type = type
            if (type === TYPES.REGION) {
                state.road_layers.forEach((item) => {
                    item.destroy()
                })
                if (state.editing_plate.region) {
                    state.region_layers = state.editing_plate.region.map((path) => {
                        const paths = path.map(([lng, lat]) => {
                            return new window.TMap.LatLng(lat, lng)
                        })
                        const polygon = new window.TMap.MultiPolygon({
                            map: window.map,
                            styles: {
                                default: new window.TMap.PolygonStyle({
                                    ...DefaultOption
                                })
                            },
                            geometries: [
                                {
                                    paths
                                }
                            ]
                        })
                        registerPolygonEditor(polygon, newPath => {
                            path.splice(0, path.length, ...newPath.map(({ lng, lat }) => ([lng, lat])))
                        })
                        return polygon
                    })
                } else {
                    state.editing_plate.region = []
                }
            } else if (type === TYPES.ROAD) {
                state.region_layers && state.region_layers.forEach((item) => {
                    item.destroy()
                })
                if (state.editing_plate.coordinates) {
                    state.road_layers = state.editing_plate.coordinates.map((path) => {
                        const paths = path.map(([lng, lat]) => {
                            return new window.TMap.LatLng(lat, lng)
                        })
                        return new window.TMap.MultiPolyline({
                            map: window.map,
                            styles: {
                                default: new window.TMap.PolylineStyle({
                                    ...DefaultRoadOption
                                })
                            },
                            geometries: [
                                {
                                    paths
                                }
                            ]
                        })
                    })
                } else {
                    state.editing_plate.coordinates = []
                }
            }
        },
        changeEditStatus(state, edit_status) {
            state.edit_status = edit_status
        },
        addRegion (state, geometry) {
            mouseTool.getActiveOverlay().overlay.setGeometries([])
            const bounds = geometry.paths.map(({
                lng,
                lat
            }) => {
                return [lng, lat]
            })
            const layer = new window.TMap.MultiPolygon({
                map: window.map,
                styles: {
                    default: new window.TMap.PolygonStyle({
                        ...DefaultOption
                    })
                },
                geometries: [
                    {
                        paths: geometry.paths
                    }
                ]
            })
            state.region_layers.push(layer)
            const current_layer_index = state.region_layers.length - 1
            layer.on('dblclick', (e) => {
                if (state.selected_region_layer > -1 && state.region_layers.length) {
                    const old_layer = state.region_layers[state.selected_region_layer]
                    old_layer && old_layer.setStyles({ default: new window.TMap.PolygonStyle({ ...DefaultOption }) })
                }
                state.selected_region_layer = current_layer_index
                layer.setStyles({
                    default: new window.TMap.PolygonStyle({
                        ...DefaultOption,
                        color: 'rgba(255, 68, 102, 0.3)',
                        borderColor: '#ee3355'
                    })
                })
            })
            registerPolygonEditor(layer, path => bounds.splice(0, bounds.length, ...path.map(({ lng, lat }) => ([lng, lat]))))
            state.editing_plate.region.push(bounds)
        },
        startEditPlolygon(state) {
            if (state.edit_type === TYPES.REGION) {
                const coords = state.region_layers.map(polygon => {
                    const geometry = polygon.getGeometries()[0]
                    const paths = geometry.paths
                    polygon.__editor.select([geometry.id])
                    return paths
                }).flat()
                const sw = new window.TMap.LatLng(Math.min(...coords.map((coord) => coord.lat)), Math.min(...coords.map((coord) => coord.lng)))
                const ne = new window.TMap.LatLng(Math.max(...coords.map((coord) => coord.lat)), Math.max(...coords.map((coord) => coord.lng)))
                mouseTool.disable()
                window.map.fitBounds(new window.TMap.LatLngBounds(sw, ne), { padding: 50 })
            }
        },
        finishEditPolygon(state) {
            mouseTool.enable()
            state.editing_plate.region = state.region_layers.map(polygon => {
                polygon.__editor.select([])
                const paths = polygon.getGeometries()[0].paths
                return paths.map(({lat, lng}) => [lng, lat])
            })
        },
        delRegin (state, i) {
            state.editing_plate.region.splice(i, 1)
            const [layer] = state.region_layers.splice(i, 1)
            state.selected_region_layer = -1
            layer.destroy()
        },
        addRoads (state, geometry) {
            mouseTool.getActiveOverlay().overlay.setGeometries([])
            const bounds = geometry.paths.map(({
                lng,
                lat
            }) => {
                return [lng, lat]
            })
            const layer = new window.TMap.MultiPolyline({
                map: window.map,
                styles: {
                    default: new window.TMap.PolylineStyle({
                        ...DefaultRoadOption
                    })
                },
                geometries: [
                    {
                        paths: geometry.paths
                    }
                ]
            })
            state.road_layers.push(layer)
            const current_layer_index = state.road_layers.length - 1
            layer.on('dblclick', (e) => {
                if (state.selected_road_layer > -1 && state.road_layers.length) {
                    const old_layer = state.road_layers[state.selected_road_layer]
                    old_layer && old_layer.setStyles({ default: new window.TMap.PolylineStyle({ ...DefaultRoadOption }) })
                }
                state.selected_road_layer = current_layer_index
                layer.setStyles({
                    default: new window.TMap.PolylineStyle({
                        ...DefaultRoadOption,
                        color: 'rgba(255, 68, 102, 1)'
                    })
                })
            })
            state.editing_plate.coordinates.push(bounds)
        },
        delRoad (state, i) {
            state.editing_plate.coordinates.splice(i, 1)
            const [layer] = state.road_layers.splice(i, 1)
            state.selected_road_layer = -1
            layer.destroy()
        },
        selectLayer (state, i) {
            const type = state.edit_type
            const key = 'selected_' + type  + '_layer'
            const layer_key = `${type}_layers`
            if (state[key] > -1) {
                const older_layer = state[layer_key][state[key]]
                older_layer.setStyles({
                    default: type === 'region' ? new window.TMap.PolygonStyle({
                        ...DefaultOption
                    }) : new window.TMap.PolylineStyle({
                        ...DefaultRoadOption
                    })
                })
            }
            state[key] = i
            const layer = state[`${type}_layers`][i]
            layer.setStyles({
                default: type === 'region' ? new window.TMap.PolygonStyle({
                    ...DefaultOption,
                    color: 'rgba(255, 68, 102, 0.3)',
                    borderColor: '#ee3355'
                }) : new window.TMap.PolylineStyle({
                    ...DefaultRoadOption,
                    color: 'rgba(255, 68, 102, 1)'
                })
            })
            const path = layer.getGeometries()[0].paths
            if (path && path.length) {
                console.log('move', path)
                const center = path[parseInt(path.length / 2)]
                window.map.setCenter(center)
            }
        },
        addHelpRegion (state, items) {
            const polygon = new window.TMap.MultiPolygon({
                id: 'help-region',
                map: window.map,
                styles: {
                    default: new window.TMap.PolygonStyle({
                        ...DefaultOption,
                        color: 'rgba(0, 176, 255, 0.2)',
                        borderWidth: 1
                    })
                },
                geometries: []
            })
            items.forEach(({ region }) => {
                region && region.forEach((path) => {
                    polygon.add([{
                        paths: path.map(([lng, lat]) => {
                            return new window.TMap.LatLng(lat, lng)
                        })
                    }])
                })
            })
        }
    },
    actions: {
        addHelpRegion ({ commit }, items) {
            commit('addHelpRegion', items)
        },
        selectLayer ({ commit }, i) {
            commit('selectLayer', i)
        },
        delRegin ({ commit }, i) {
            commit('delRegin', i)
        },
        delRoad ({ commit }, i) {
            commit('delRoad', i)
        },
        getList({ commit }, list) {
            commit('setList', list)
        },
        startEditPolygon({ commit }) {
            commit('startEditPlolygon')
        },
        finishEditPolygon({ commit }) {
            commit('finishEditPolygon')
        },
        changePlate({ commit }, editing_plate) {
            commit('changePlate', editing_plate)
        },
        changeEditType({ commit }, tab) {
            commit('changeEditType', tab)
            if (tab === TYPES.REGION) {
                this.dispatch('PlateEditor/initPolygon')
            } else if (tab === TYPES.ROAD) {
                this.dispatch('PlateEditor/initPolyline')
            }
        },
        changeEditStatus({ commit }, edit_status) {
            commit('changeEditStatus', edit_status)
        },
        openEdit({ commit }, plate) {
            commit('changeEditStatus', EDIT_STATUS.EDIT)
            commit('changePlate', plate)
            this.dispatch('PlateEditor/changeEditType', TYPES.REGION)
        },
        openRegionEdit({ commit }, plate) {
            commit('changePlate', plate)
            this.dispatch('PlateEditor/changeEditType', TYPES.REGION)
        },
        openRoadsEdit({ commit }, plate) {
            commit('changePlate', plate)
            this.dispatch('PlateEditor/changeEditType', TYPES.ROAD)
        },
        initMouseTools () {
            if (mouseTool) {
                this.dispatch('PlateEditor/clearMouseTools')
            }
            console.log('init tool')
            mouseTool = new window.TMap.tools.GeometryEditor({
                map: window.map,
                overlayList: [],
                actionMode: window.TMap.tools.constants.EDITOR_ACTION.DRAW,
                snappable: true
            })
        },
        initPolygon({ commit }) {
            this.dispatch('PlateEditor/initMouseTools')
            mouseTool.on('draw_complete', (geometry) => {
                commit('addRegion', geometry)
            })
            mouseTool.addOverlay({
                id: 'draw-polygon',
                overlay: new window.TMap.MultiPolygon({
                    map: window.map,
                    styles: {
                        default: new window.TMap.PolygonStyle({
                            ...DefaultOption
                        })
                    }
                }),
            })
            mouseTool.setActiveOverlay('draw-polygon')
        },
        initPolyline ({ commit }) {
            this.dispatch('PlateEditor/initMouseTools')
            mouseTool.on('draw_complete', (geometry) => {
                commit('addRoads', geometry)
            })
            mouseTool.addOverlay({
                id: 'draw-polyline',
                overlay: new window.TMap.MultiPolyline({
                    map: window.map,
                    styles: {
                        default: new window.TMap.PolylineStyle({
                            ...DefaultRoadOption
                        })
                    }
                }),
            })
            mouseTool.setActiveOverlay('draw-polyline')
        },
        clearMouseTools () {
            if (mouseTool) {
                mouseTool.destroy()
            }
        }
    }
}
